module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsBAMAAADsqkcyAAAAAXNSR0IB2cksfwAAACRQTFRFAAAA////////////////////////////////////////////tAmN6QAAAAx0Uk5TAFCAZwhPIGh4EB93J/bGcwAAAFpJREFUeJxjEFKCAhMGBmcYW5UBxlJSY2BIgnNGheksXARjdTIwzICx1Rnc0qBgAgMDJ4ydwkBL4LUKCkBWwthLEA7cycAwG8ZWHkQhOKKF4Zm7hIHBHcZWBAAf0ITi+c9abwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu--icon--apps-unselected@2x.png
// module id = 926
// module chunks = 0